import { useTranslation } from 'react-i18next';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';

const languages = ['HU', 'EN', 'DE', 'FR'];

const LanguageSelector = ({ selectedLanguage, setLanguage }) => {
  const { t } = useTranslation();

  return (
    <div className="language-selector">
      <FormControl fullWidth>
        <InputLabel id="">{t('language')}</InputLabel>
        <Select value={selectedLanguage} label={t('language')} onChange={setLanguage}>
          {languages.map(language => (
            <MenuItem key={language} value={language.toLowerCase()}>
              {language}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  );
};

export default LanguageSelector;
